<template>
  <div class="menu">
    <el-row type="flex">
      <el-col :span="6">
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('menu.menuTree') }}</span>
            <span class="i-icon">
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-create"
                @click="addTree"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-edit"
                @click="editTree"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-delete"
                @click="deleteTree"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px"
                icon-class="company-reset"
                @click="getData"
              />
            </span>
          </div>
          <el-input :placeholder="$t('menu.filterPlace')" v-model="filterText"></el-input>
          <el-tree
            :data="data"
            :props="defaultProps"
            default-expand-all
            highlight-current
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            ref="tree"
            v-bind:style="{ height: heightTree, 'overflow-y': 'auto' }"
          ></el-tree>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">{{ $t('menu.menuDetail') }}</div>
          <el-form
            ref="menuDetail"
            label-position="right"
            label-width="auto"
            :model="menuDetail.attributes"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('menu.menuName')">
                  <el-input v-model="menuDetail.label" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.type')">
                  <el-input
                    v-if="menuDetail.attributes.type == undefined"
                    value
                    readonly
                  ></el-input>
                  <el-input
                    v-if="menuDetail.attributes.type == 1"
                    :value="$t('menu.menu')"
                    readonly
                  ></el-input>
                  <el-input
                    v-if="menuDetail.attributes.type == 2"
                    :value="$t('menu.catalog')"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.menuUrl')">
                  <el-input v-model="menuDetail.attributes.menuUrl" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.buttonStyle')">
                  <el-input v-model="menuDetail.attributes.menuStyle" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.sortNo')">
                  <el-input v-model="menuDetail.attributes.sortNo" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.remark')">
                  <el-input v-model="menuDetail.attributes.remark" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('menu.menuBtn') }}</span>
            <span class="i-icon">
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-create"
                @click="addTreeBtn"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-edit"
                @click="editTreeBtn"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="company-delete"
                @click="deleteTreeBtn"
              />
              <svg-icon
                class="icon-img"
                style="font-size: 16px"
                icon-class="company-reset"
                @click="getListData"
              />
            </span>
          </div>
          <tree-table
            ref="treeTable"
            :buttonList="[]"
            :loading="false"
            :data="tableData"
            rowKey="id"
            labelField="label"
            :height="heightTable"
          >
            <vxe-table-column
              field="label"
              :title="$t('menu.table.btnName')"
              width="120"
              tree-node
            ></vxe-table-column>
            <vxe-table-column
              v-for="(item, index) in columnList"
              :key="index"
              :fixed="item.fixed"
              :width="item.width"
              :sortable="item.sortable"
              :field="item.prop"
              :title="item.label"
            >
              <template slot-scope="scope">
                <span v-if="item.prop === 'doubleClickFlag'">{{
                  { 0: '普通按钮', 1: '双击(表格)', 2: '单击(树)' }[
                    scope.row['attributes'][item.prop]
                  ]
                }}</span>
                <span v-else-if="item.prop == 'buttonLocation'">{{
                  scope.row['attributes'][item.prop]
                    ? buttonLocationOptins.find(
                        (it) => it.value == scope.row['attributes'][item.prop]
                      ).label
                    : scope.row['attributes'][item.prop]
                }}</span>
                <span v-else>{{ scope.row['attributes'][item.prop] }}</span>
              </template>
            </vxe-table-column>
          </tree-table>
        </el-card>
      </el-col>
    </el-row>
    <addMenu v-on:getData="getData" :dataList="dataList" ref="addMenu"></addMenu>
    <editMenu v-on:getData="getData" :dataList="dataList" ref="editMenu"></editMenu>
    <addMenuBtn v-on:getListData="getListData" ref="addMenuBtn"></addMenuBtn>
    <editMenuBtn v-on:getListData="getListData" ref="editMenuBtn"></editMenuBtn>
  </div>
</template>
<script>
  import API from '@/api/systemManage/menu.js';
  import TreeTable from '@/components/TreeTable';
  import addMenu from './addModal/addMenu';
  import editMenu from './editModal/editMenu';
  import addMenuBtn from './addModal/addMenuBtn';
  import editMenuBtn from './editModal/editMenuBtn';

  export default {
    name: 'Menu',
    components: {
      TreeTable,
      addMenu,
      editMenu,
      addMenuBtn,
      editMenuBtn,
    },
    data() {
      return {
        data: [],
        filterText: '',
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        menuDetail: {
          attributes: {},
        },
        tableData: [],
        dataList: [],
        buttonLocationOptins: [
          { value: 'list', label: '列表' },
          { value: 'other', label: '其他' },
        ],
      };
    },
    computed: {
      //表格显示字段
      columnList() {
        return [
          {
            prop: 'buttonStyle',
            label: this.$t('menu.table.btnStyle'),
            width: 180,
          },
          {
            prop: 'buttonUrl',
            label: this.$t('menu.table.methodName'),
            width: 120,
          },
          { prop: 'doubleClickFlag', label: this.$t('menu.buttonType') },
          { prop: 'sortNo', label: this.$t('menu.sortNo') },
          { prop: 'authCode', label: '权限范围' },
          { prop: 'buttonLocation', label: '使用范围' },
        ];
      },
      heightTable() {
        return window.innerHeight - 330 + 'px';
      },
      heightTree() {
        return window.innerHeight - 195 + 'px';
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getData();
      });
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    methods: {
      //获取菜单树
      getData() {
        this.$axios.post(API.GET_LIST_API).then((res) => {
          if (0 == res.data.code) {
            this.data = res.data.data.rootTree;
            this.dataList = res.data.data.rootTree;
            this.getSelectedNode(this.dataList, this.dataList);
            this.menuDetail = {
              attributes: {},
            };
            this.tableData = [];
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //选择一条菜单
      handleNodeClick(data) {
        this.menuDetail = data;
        //获取菜单按钮
        if ('menu' == this.menuDetail.type) {
          this.getListData();
        } else {
          this.tableData = [];
        }
      },
      //获取按钮
      getListData() {
        if (!this.menuDetail.attributes.menuCode) {
          return;
        }
        const params = {
          menuCode: this.menuDetail.attributes.menuCode,
        };
        this.$axios.post(API.GET_BTN_LIST_API, params).then((res) => {
          if (0 == res.data.code) {
            this.tableData = res.data.data.all;
            this.$refs.treeTable.reloadTable(this.tableData);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //新增菜单
      addTree() {
        if ('company' == this.menuDetail.type) {
          this.$message({
            showClose: true,
            message: this.$t('menu.addTips'),
            type: 'error',
          });
          return;
        }
        this.$refs.addMenu.openDialog(true, this.menuDetail);
      },
      //修改菜单
      editTree() {
        if ('menu' != this.menuDetail.type) {
          this.$message({
            showClose: true,
            message: this.$t('menu.editTips'),
            type: 'error',
          });
          return;
        }
        this.$refs.editMenu.openDialog(true, this.menuDetail);
      },
      //删除菜单
      deleteTree() {
        if (!this.menuDetail.attributes.authCode) {
          this.$message({
            showClose: true,
            message: this.$t('menu.deleteTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            const params = {
              authCode: this.menuDetail.attributes.authCode,
            };
            this.loading.startLoading();
            this.$axios.post(API.DELETE_MENU_API, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //新增菜单按钮
      addTreeBtn() {
        if (!this.menuDetail.attributes.authCode || this.menuDetail.attributes.type == '2') {
          this.$message({
            showClose: true,
            message: this.$t('menu.addTreeTips'),
            type: 'error',
          });
          return;
        }
        this.$refs.addMenuBtn.openDialog(
          true,
          this.menuDetail,
          this.$refs.treeTable.getCurrentRecord()
        );
      },
      //修改按钮
      editTreeBtn() {
        if (!this.$refs.treeTable.getCurrentRecord()) {
          this.$message({
            showClose: true,
            message: this.$t('menu.editBtnTips'),
            type: 'error',
          });
          return;
        }
        this.$refs.editMenuBtn.openDialog(true, this.$refs.treeTable.getCurrentRecord().attributes);
      },
      //删除按钮
      deleteTreeBtn() {
        if (!this.$refs.treeTable.getCurrentRecord()) {
          this.$message({
            showClose: true,
            message: this.$t('menu.deleteTreeTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.delete'), this.$t('confirm.tips'))
          .then(() => {
            this.$axios
              .post(API.DELETE_MENU_BTN_API, {
                authCode: this.$refs.treeTable.getCurrentRecord().attributes.authCode,
              })
              .then((res) => {
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getListData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .i-icon {
    float: right;
    i {
      cursor: pointer;
    }
  }
</style>
